import { valibotResolver } from '@hookform/resolvers/valibot';
import { object } from 'valibot';

import StepFacilities from '../components/Steps/StepFacilities';
import StepNotifications from '../components/Steps/StepNotifications';
import StepPersonalInfo from '../components/Steps/StepPersonalInfo';
import StepRegionAndPermissions from '../components/Steps/StepRegionAndPermissions';
import {
  schemaFacilityStep,
  schemaNotificationsStep,
  schemaPersonalInfoStep,
  schemaRegionAndPermissionsStep,
} from '../constants/schemaUser';

export const getUserFormSteps = () => [
  {
    step: 1,
    stepName: 'Personal info',
    stepComponent: StepPersonalInfo,
    previousStepIndex: 'close',
    nextStepIndex: 1,
    schema: valibotResolver(schemaPersonalInfoStep),
  },
  {
    step: 2,
    stepName: 'Facilities',
    stepComponent: StepFacilities,
    previousStepIndex: 0,
    nextStepIndex: 2,
    schema: valibotResolver(schemaFacilityStep),
  },
  {
    step: 3,
    stepName: 'Region Settings & Permissions',
    stepComponent: StepRegionAndPermissions,
    previousStepIndex: 1,
    nextStepIndex: 3,
    schema: valibotResolver(schemaRegionAndPermissionsStep),
  },
  {
    step: 4,
    stepName: 'Notifications',
    stepComponent: StepNotifications,
    previousStepIndex: 2,
    nextStepIndex: 'end',
    schema: valibotResolver(
      object({
        ...schemaPersonalInfoStep.entries,
        ...schemaFacilityStep.entries,
        ...schemaRegionAndPermissionsStep.entries,
        ...schemaNotificationsStep.entries,
      }),
    ),
  },
];
